import { createSlice } from '@reduxjs/toolkit';

/* eslint-disable no-param-reassign */

const createInitialPlaceholders = (count = 6) =>
	[...Array(count)].map((_, i) => ({
		uuid: `${i}`,
		isPlaceholder: true
	}));

const initialState = {
	inventory: createInitialPlaceholders(),
	pageInfo: {
		enableMediaCarousel: false
	},
	// Simplify the loading states into a single object
	loadingStates: {
		isLoading: true,
		isRequesting: false,
		isInitialRequest: true,
		requestFailed: false
	}
};

const inventorySlice = createSlice({
	name: 'inventory',
	initialState,
	reducers: {
		setInventoryItems(state, action) {
			state.inventory = action.payload;
		},
		setLoadingStates(state, action) {
			state.loadingStates = { ...state.loadingStates, ...action.payload };
		}
	}
});

export const { setInventoryItems, setLoadingStates } = inventorySlice.actions;

export default inventorySlice.reducer;
